import { GzPriceDiscountWebComponent } from './component/GzPriceDiscountWebComponent';

export { GzPriceDiscountWebComponent };
